import "./PageObject.scss"
import React, {useEffect, useState} from "react";
import {useParams} from "react-router";
import {IconVideo} from "../icons/IconVideo";
import {IconImages} from "../icons/IconImages";
import {useUnitsState} from "../store/UnitsState";
import {IObject} from "../interfaces/IObject";
import {UnitRoomMapCard} from "../cmp/unit/UnitRoomMapCard";
import {TopRightNav} from "../cmp/header/TopRightNav";
import {BreadCrumbs} from "../cmp/header/BreadCrumbs";
import {YearFilterButtons} from "../cmp/year/YearFilterButtons";

export function PageObject() {

  const store = useUnitsState()
  let params = useParams<{ object_name: string }>();
  let [object, setObject] = useState<IObject | undefined>(undefined);

  useEffect(() => {
    if (store.loading) return
    if (params.object_name) {
      object = store.objects.find(o => o.name === params.object_name)
      if(object) {
        setObject(object)
        // store.setSelectedObject(object)
      }
    }
  }, [store.loading])

  function Header({object}: { object: IObject }) {

    return <header style={{backgroundImage: `url('${object.images[0]}')`}}>

      <section>
        <BreadCrumbs contrast={true} object={object} />
        <div data-component="TopRightNav" style={{color:'white'}}><TopRightNav/></div>
      </section>

      <header>
        <div className="region-header-media">
          <IconVideo/> Відео
          <IconImages/> Фото
        </div>
        <h1>{object.name}</h1>
        <div className="region-header-location">
          <div data-component="Orientir" style={{color: 'white'}}></div>
          <section>
            {object.sections_completed ? <a href="#">{object.sections_completed} збудовано</a> : null}
            {object.sections_in_progress > 0 ? <a href="#">{object.sections_in_progress} будується</a> : null}
          </section>
        </div>
      </header>

    </header>
  }

  function Main({object}: { object: IObject }) {
    return <main>
      <YearFilterButtons/>
      <div data-component="UnitRoomMapCard">
        <UnitRoomMapCard url={""} rooms={object.room_data}/>
      </div>
    </main>
  }

  if (store.loading) {
    return null
  }

  return <div id="app-storefront-project">

    {object ? <>
      <Header object={object}/>
      <Main object={object}/>
    </> : <h1>Об'єкт не знайдено</h1>}

  </div>
}
